// extracted by mini-css-extract-plugin
module.exports = {"reportForm":"style__reportForm__mxbQ+","shapeReport":"style__shapeReport__4zzv4"};